import CachedIcon from '@mui/icons-material/Cached';
import { styled } from '@mui/material/styles';
import { QButton, QTypography, QThemeProvider } from '@kw/quokka-ui';

const StyledTypography = styled(QTypography)`
  font-size: 13px;
  line-height: 20px;
  color: #3b3b3b;
  text-transform: none;
  font-weight: 700;
`;

export const ResetButton = ({ onClick }) => (
  <QThemeProvider>
    <QButton
      sx={{ width: '88px', height: '32px', padding: '9px 16px' }}
      // variant=""
      color="primary"
      onClick={onClick}
      startIcon={<CachedIcon fontSize="small" />}
    >
      <StyledTypography>Reset</StyledTypography>
    </QButton>
  </QThemeProvider>
);
